import { render, staticRenderFns } from "./FavoriteItems.vue?vue&type=template&id=0440a204&"
import script from "./FavoriteItems.vue?vue&type=script&lang=js&"
export * from "./FavoriteItems.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteItems.vue?vue&type=style&index=0&id=0440a204&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductCardDefault: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ProductCard/ProductCardDefault.vue').default})
